import { animate } from 'motion';
import { EASING_OPTION } from '@bg-shared';

const SCROLL_DURATION = 150;

export const scrollToTarget = (
    scrollbar: HTMLElement,
    target: HTMLElement,
    smooth = true,
): void => {
    const targetRect = target.getBoundingClientRect();
    const scrollbarRect = scrollbar.getBoundingClientRect();
    const targetX = targetRect.x || targetRect.left;
    const scrollbarX = scrollbarRect.x || scrollbarRect.left;
    const start = scrollbar.scrollLeft;
    const centerX = scrollbarX + scrollbarRect.width / 2;
    const targetC = targetX + targetRect.width / 2;
    const position = centerX - targetC;

    if (smooth) {
        animate(
            (progress) => {
                scrollbar.scrollLeft = start - position * progress;
            },
            { duration: SCROLL_DURATION / 1000, easing: EASING_OPTION.EASE_OUT_CUBIC },
        );
    } else {
        scrollbar.scrollLeft = start - position;
    }
};
